var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Row',[_c('Col',{attrs:{"span":"24"}},[_c('span',{staticClass:"expand-key"},[_vm._v("请求数据: ")]),_c('span',{staticClass:"expand-value"},[_vm._v(_vm._s(_vm.row.data))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }